const LOCALES = { en: 'en-GB', id: 'id-ID' };

// The team works on Jakarta time, whatever the viewer's browser is set to.
export function formatDateTime(iso, language = 'en') {
  const date = new Date(iso);
  if (!iso || Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(LOCALES[language] || LOCALES.en, { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Asia/Jakarta' }).format(date);
}

export function formatBytes(bytes) {
  if (!Number.isFinite(bytes)) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export const fillTemplate = (template, values) => Object.entries(values).reduce(
  (text, [key, value]) => text.replaceAll(`{${key}}`, String(value)),
  template,
);

// Prefer the app's own wording for errors the backend explains with a code; otherwise a generic line.
export function describeApiError(error, t, fallback) {
  return (error?.code && t.errorCode?.[error.code]) || fallback || t.loadFailed;
}
